import reqwest from 'reqwest';
import { apiUrl } from './config';
import session from './session';

export default {
  checkWorkerSign2c(data) {
    return reqwest({
      url: `${apiUrl}/customer-api/api/v2/worker/checkWorkerSign`,
      data,
      headers: {
        sessionId: session.get(),
      },
    });
  },
  checkWorkerSign2b(data) {
    return reqwest({
      url: `${apiUrl}/business-api/api/v2/worker/checkWorkerSign`,
      data,
      headers: {
        sessionId: session.get(),
      },
    });
  },
};
